import { render, staticRenderFns } from "./NicheEdit_Mobile.vue?vue&type=template&id=136d93e2&scoped=true&"
import script from "./NicheEdit_Mobile.vue?vue&type=script&lang=js&"
export * from "./NicheEdit_Mobile.vue?vue&type=script&lang=js&"
import style0 from "./NicheEdit_Mobile.vue?vue&type=style&index=0&id=136d93e2&prod&lang=css&"
import style1 from "./NicheEdit_Mobile.vue?vue&type=style&index=1&id=136d93e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d93e2",
  null
  
)

export default component.exports